import { useState } from 'react';
import { Link } from 'react-router-dom';
import { movies } from '../../../mocks/movies';
import MovieListRow from '../../../components/base/MovieListRow';
import { sortMovies, type SortKey } from '../../../utils/movies';

const TABS: { key: SortKey; label: string; icon: string }[] = [
  { key: 'updated', label: '最新上线', icon: 'ri-time-line' },
  { key: 'views', label: '热门排行', icon: 'ri-fire-line' },
];

export default function RankBoard() {
  const [tab, setTab] = useState<SortKey>('updated');
  const list = sortMovies(movies, tab).slice(0, 6);

  return (
    <section className="w-full px-4 md:px-8 py-10 md:py-14 bg-background-100">
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-6">
        <div className="flex items-center gap-3">
          <span className="w-1 h-6 md:h-7 rounded-full bg-primary-500"></span>
          <h2 className="font-heading font-bold text-lg md:text-2xl text-foreground-950">最新上线 · 热门排行</h2>
        </div>
        <div className="flex items-center gap-1 p-1 rounded-full bg-background-200 w-fit max-w-full overflow-hidden">
          {TABS.map((item) => (
            <button
              key={item.key}
              type="button"
              onClick={() => setTab(item.key)}
              className={`flex items-center gap-1.5 px-4 py-1.5 rounded-full text-sm font-medium whitespace-nowrap transition-colors cursor-pointer ${
                tab === item.key
                  ? 'bg-primary-500 text-background-50'
                  : 'text-foreground-600 hover:text-foreground-900'
              }`}
            >
              <i className={item.icon} aria-hidden="true"></i>
              {item.label}
            </button>
          ))}
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-3 md:gap-4">
        {list.map((movie, index) => (
          <MovieListRow key={movie.id} movie={movie} index={index} />
        ))}
      </div>

      <div className="flex justify-center mt-8">
        <Link
          to="/category/movie"
          className="flex items-center gap-2 h-11 px-6 rounded-md border border-background-300 hover:border-primary-400 hover:text-primary-600 text-foreground-700 text-sm font-medium whitespace-nowrap transition-colors cursor-pointer"
        >
          查看完整榜单
          <i className="ri-arrow-right-line" aria-hidden="true"></i>
        </Link>
      </div>
    </section>
  );
}